import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { I18n } from 'react-redux-i18n';
import { NavLink } from 'react-router-dom';

import {
  dashboard, building, flow, userIcon, search, importFile, briefcase, briefcaseCheck, settings, logout
} from '../../app/utils/icons';

export const mainList = (
  <div>

    <NavLink
      to="/dashboard"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {dashboard}
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </NavLink>
  </div>
);

export const configurationList = (
  <div>
    <ListSubheader inset>Configurações</ListSubheader>

    <NavLink
      to="/company/list"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {building}
        </ListItemIcon>
        <ListItemText primary="Empresas" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/flow/list"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {flow}
        </ListItemIcon>
        <ListItemText primary="Fluxo de Atividades" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/account/list"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {userIcon}
        </ListItemIcon>
        <ListItemText primary="Usuários" />
      </ListItem>
    </NavLink>
  </div>
);

export const noteList = (
  <div>
    <ListSubheader inset>Notas</ListSubheader>

    <NavLink
      to="/invoice/list"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {search}
        </ListItemIcon>
        <ListItemText primary="Consulta" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/invoice/lot"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {importFile}
        </ListItemIcon>
        <ListItemText primary="Registro em Lote" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/invoice/search"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {briefcase}
        </ListItemIcon>
        <ListItemText primary="Consulta de Fluxo" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/invoice/check"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {briefcaseCheck}
        </ListItemIcon>
        <ListItemText primary="Execução de Fluxo" />
      </ListItem>
    </NavLink>


  </div>
);

export const accountList = (
  <div>

 <NavLink
      to="/context"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {settings}
        </ListItemIcon>
        <ListItemText primary="Alterar Empresa" />
      </ListItem>
    </NavLink>

    <NavLink
      to="/logout"
      activeClassName="activeLink"
    >
      <ListItem button>
        <ListItemIcon>
          {logout}
        </ListItemIcon>
        <ListItemText primary="Sair" />
      </ListItem>
    </NavLink>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/dashboard/listItems.js